export const updateItemRecipe =
  <T, K extends keyof T>(key: K, value: T[K], data: Partial<T>) =>
  (draft: T[]): T[] => {
    const index = draft?.findIndex((item) => item[key] === value) ?? -1;
    if (index > -1) {
      draft[index] = {
        ...draft[index],
        ...data,
      };
    }
    return draft;
  };
